import { ElLoading } from 'element-plus'

// export default {
//   install(app) {
//     app.config.globalProperties.$loading = ElLoading.service
//   }
// }

let loadingCount = 0
let loadingInstance

export function showLoading() {
  if (loadingCount === 0) {
    loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  loadingCount++
}

export function hideLoading() {
  if (loadingCount > 0) {
    loadingCount--
    if (loadingCount === 0 && loadingInstance) {
      loadingInstance.close()
    }
  }
}
